function initFeaturedProductNewSwiper(scope) {

    if (typeof Swiper === 'undefined') {
        return;
    }

    const container = scope || document;

    container.querySelectorAll('.featured-product-new').forEach(function(section) {

        section.querySelectorAll('.featured-product-new-slider').forEach(function(slider) {

            /* Already initialized */
            if (slider.swiper) {
                return;
            }

            const panel = slider.closest(
                '.featured-product-new-panel'
            );

            if (!panel) {
                return;
            }

            const nextButton = panel.querySelector(
                '.featured-product-new-arrow-next'
            );

            const prevButton = panel.querySelector(
                '.featured-product-new-arrow-prev'
            );

            const scrollbar = panel.querySelector(
                '.featured-product-new-scrollbar'
            );

            new Swiper(slider, {
                slidesPerView: 1.65,
                spaceBetween: 25,
                speed: 500,
                slidesPerGroup: 1,
                watchOverflow: true,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton
                },
                scrollbar: {
                    el: scrollbar,
                    draggable: true
                },
                breakpoints: {
                    767: {
                        slidesPerView: 3.44,
                        spaceBetween: 25
                    },

                    1036: {
                        slidesPerView: 4.68,
                        spaceBetween: 33
                    },

                    1367: {
                        slidesPerView: 5.66,
                        spaceBetween: 33
                    }
                }
            });

            /* Show only after Swiper is ready */
            panel.classList.add('swiper-ready');

        });

    });

}

/* Initial page load */
if (document.readyState === 'loading') {

    document.addEventListener(
        'DOMContentLoaded',
        function() {
            initFeaturedProductNewSwiper();
        }, {
            once: true
        }
    );

} else {

    initFeaturedProductNewSwiper();

}

/* Shopify Theme Editor only */
document.addEventListener(
    'shopify:section:load',
    function(event) {

        initFeaturedProductNewSwiper(event.target);

    }
);